import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams  } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, tap, throwError } from 'rxjs';
import { AuthService } from '../auth-service';
import {
  PartiallyDeliveredReasonDTO,
  PartiallyDeliveredReasonResult,
} from '../../pages/admin-dashboard/partially-delivered-reasons/partiallyDeliveredReason.model';


@Injectable({ providedIn: 'root' })
export class PartiallyDeliveredReasonsService {
  private authService = inject(AuthService);
  private http = inject(HttpClient);
  private API = environment.pharmacyMgtApiUrl;

  createReason(dto: PartiallyDeliveredReasonDTO) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.post<void>(`${this.API}/orders/partially/delivered/reason`, dto, { headers }).pipe(
      tap(() => console.log('Partially delivered reason created successfully')),
      catchError(this.handleError),
    );
  }

updateReason(
  reasonId: number,
  dto: PartiallyDeliveredReasonDTO
) {
  const token = this.authService.getAccessToken();

  let headers = new HttpHeaders();

  if (token) {
    headers = headers.set(
      'Authorization',
      `Bearer ${token}`
    );
  }

  return this.http.put<void>(
    `${this.API}/orders/partially/delivered/reason/${reasonId}`,
    dto,
    { headers }
  ).pipe(
    tap(() =>
      console.log(
        'Partially delivered reason updated successfully'
      )
    ),
    catchError(this.handleError),
  );
}



deleteReason(reasonId: number) {
  const token = this.authService.getAccessToken();

  let headers = new HttpHeaders();

  if (token) {
    headers = headers.set(
      'Authorization',
      `Bearer ${token}`
    );
  }

  return this.http.delete<void>(
    `${this.API}/orders/partially/delivered/reason/${reasonId}`,
    { headers }
  ).pipe(
    tap(() =>
      console.log(
        'Partially delivered reason deleted successfully'
      )
    ),
    catchError(this.handleError),
  );
}
 getAllReasons(
    lang: 'ar' | 'en',
    paramsIn?: {
      quickSearch?: string;

      pageNum?: number;
      pageSize?: number;

      orderBy?:
        | 'TITLE'
        | 'CREATION_DATE'
        | 'LAST_MODIFICATION_DATE';

      orderDir?: 'ASC' | 'DESC';

      createdOnFrom?: string;
      createdOnTo?: string;

      lastModifiedOnFrom?: string;
      lastModifiedOnTo?: string;
    }
  ) {
    let params = new HttpParams();

    if (paramsIn) {
      if (paramsIn.quickSearch) {
        params = params.set(
          'quickSearch',
          paramsIn.quickSearch
        );
      }

      if (paramsIn.pageNum !== undefined) {
        params = params.set(
          'pageNum',
          paramsIn.pageNum.toString()
        );
      }

      if (paramsIn.pageSize !== undefined) {
        params = params.set(
          'pageSize',
          paramsIn.pageSize.toString()
        );
      }

      if (paramsIn.orderBy) {
        params = params.set(
          'orderBy',
          paramsIn.orderBy
        );
      }

      if (paramsIn.orderDir) {
        params = params.set(
          'orderDir',
          paramsIn.orderDir
        );
      }

      if (paramsIn.createdOnFrom) {
        params = params.set(
          'createdOnFrom',
          paramsIn.createdOnFrom
        );
      }

      if (paramsIn.createdOnTo) {
        params = params.set(
          'createdOnTo',
          paramsIn.createdOnTo
        );
      }

      if (paramsIn.lastModifiedOnFrom) {
        params = params.set(
          'lastModifiedOnFrom',
          paramsIn.lastModifiedOnFrom
        );
      }

      if (paramsIn.lastModifiedOnTo) {
        params = params.set(
          'lastModifiedOnTo',
          paramsIn.lastModifiedOnTo
        );
      }
    }

    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set(
        'Authorization',
        `Bearer ${token}`
      );
    }

    headers = headers.set(
      'Accept-Language',
      lang
    );

    return this.http
      .get<PartiallyDeliveredReasonResult>(`${this.API}/orders/partially/delivered/reason`,
        {
          params,
          headers,
        }
      )
      .pipe(
        catchError(this.handleError)
      );
  }



  private handleError(error: HttpErrorResponse) {
    return throwError(() => error.error);
  }
}

